// AUTO-GENERATED from the live ester1.fi content (DatoCMS export).
// Safe to hand-edit: this is now the source of truth for site content.

const { asset } = require('./assets');

const sijainti = {
  seoMetaTags: {
    tags: [
      {
        tagName: "title",
        content: "Sijainti & Palvelut | Ester1",
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:title",
          content: "Sijainti & Palvelut",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:title",
          content: "Sijainti & Palvelut",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "description",
          content: "Junalla liikkuessasi Ester1 on aina matkasi varrella, ja autollakin viiletät alle 10 minuutissa kaikille pääväylille.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:description",
          content: "Junalla liikkuessasi Ester1 on aina matkasi varrella, ja autollakin viiletät alle 10 minuutissa kaikille pääväylille.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:description",
          content: "Junalla liikkuessasi Ester1 on aina matkasi varrella, ja autollakin viiletät alle 10 minuutissa kaikille pääväylille.",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:card",
          content: "summary",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:modified_time",
          content: "2022-06-21T09:11:18Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "article:published_time",
          content: "2019-12-30T15:27:14Z",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:locale",
          content: "fi_FI",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:type",
          content: "article",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:site_name",
          content: "Ester1 – toimistotila keskellä uutta Pasilaa ",
        },
      },
      {
        tagName: "meta",
        attributes: {
          property: "og:image",
          content: "/content-images/1614931354-neuvottelusquare-uusi.jpg",
        },
      },
      {
        tagName: "meta",
        attributes: {
          name: "twitter:image",
          content: "/content-images/1614931354-neuvottelusquare-uusi.jpg",
        },
      },
    ],
  },
  title: "Sijainti ja palvelut",
  lead: "Syö aamupala Espoossa, käy palaverissa Tampereella ja lähde illalliselle Kamppiin. Junalla liikkuessasi Ester1 on aina matkasi varrella, ja autollakin viiletät alle 10 minuutissa kaikille pääväylille.",
  content: "<p>Ester1 sijaitsee osoitteessa Esterinportti 1. Pasilan asema ja Tripla ovat kirjaimellisesti keih&auml;&auml;nheiton p&auml;&auml;ss&auml; ja junalla kiid&auml;t keskustaan viidess&auml; minuutissa. Keskuspuiston l&auml;pi polkevat ty&ouml;matkalaiset saavat nauttia hiekan rapinasta ja metsik&ouml;n tuoksusta keskell&auml; Helsinki&auml;.</p>",
  heroLayer: {
    alpha: 26,
    blue: 38,
    green: 24,
    red: 0,
  },
  imgHero: asset("1653900506-julkisivu-1.jpg", {
    sizes: "(max-width: 1600px) 100vw, 1600px",
    aspectRatio: 1.7769,
  }),
  autollaIkoni: asset("1577112506-i-car.svg"),
  autollaOtsikko: "Autolla",
  autollaTaulukko: "<table border=\"1\" style=\"border-collapse: collapse; width: 100%;\"><tbody><tr><td style=\"width: 65%;\">Tampereen v&auml;yl&auml;lle</td><td style=\"width: 35%;\">4 min</td></tr><tr><td style=\"width: 50%;\">Tuusulan v&auml;yl&auml;lle</td><td style=\"width: 50%;\">6 min</td></tr><tr><td style=\"width: 50%;\">Lahden v&auml;yl&auml;lle</td><td style=\"width: 50%;\">10 min</td></tr><tr><td style=\"width: 50%;\">Turun v&auml;yl&auml;lle</td><td style=\"width: 50%;\">10 min</td></tr><tr><td style=\"width: 50%;\">L&auml;nsiv&auml;yl&auml;lle</td><td style=\"width: 50%;\">14 min</td></tr></tbody></table>",
  junallaIkoni: asset("1577112519-i-train.svg"),
  junallaOtsikko: "Junalla",
  junallaTaulukko: "<table border=\"1\" style=\"border-collapse: collapse; width: 100%;\"><tbody><tr><td style=\"width: 65%;\">Turku</td><td style=\"width: 35%;\">1 t 48 min</td></tr><tr><td style=\"width: 50%;\">Tampere</td><td style=\"width: 50%;\">1 t 26 min</td></tr><tr><td style=\"width: 50%;\">Lentokentt&auml;</td><td style=\"width: 50%;\">23 min</td></tr><tr><td style=\"width: 50%;\">Helsingin keskusta</td><td style=\"width: 50%;\">5 min</td></tr><tr><td style=\"width: 50%;\">Espoon keskusta</td><td style=\"width: 50%;\">19 min</td></tr></tbody></table>",
  kuva2: asset("1577112833-esteri-karttakuva-1000x1000-v2.jpg", {
    sizes: "(max-width: 536px) 100vw, 536px",
    aspectRatio: 1,
  }),
  otsikko2: "Yksi minuutti Triplaan",
  otsikko3: "Vilkaisu massiiviseen Triplaan",
  pyorallaIkoni: asset("1577112501-i-bike.svg"),
  pyorallaOtsikko: "Pyörällä",
  pyorallaTaulukko: "<table border=\"1\" style=\"border-collapse: collapse; width: 100%;\"><tbody><tr><td style=\"width: 65%;\">Munkkiniemi</td><td style=\"width: 35%;\">13 min</td></tr><tr><td style=\"width: 50%;\">Haaga</td><td style=\"width: 50%;\">15 min</td></tr><tr><td style=\"width: 50%;\">T&ouml;&ouml;l&ouml;ntori</td><td style=\"width: 50%;\">10 min</td></tr><tr><td style=\"width: 50%;\">Helsingin keskusta</td><td style=\"width: 50%;\">13 min</td></tr><tr><td style=\"width: 50%;\">Arabianranta</td><td style=\"width: 50%;\">11 min</td></tr></tbody></table>",
  teksti2: "On ilo käydä kollegan tai asiakkaan kanssa lounaalla, kun Triplasta löytää makuja maailman jokaiselta mantereelta. Pasilan ylpeyden uumenista löytyy myös runsaasti liikuntapalveluja aina rantalentopallosta kuntosaleihin. Ja mikä parasta, merkkiliikkeet ja ruokakaupat ovat aina kotimatkasi varrella.",
  yhteydetOtsikko: "Yhteydet",
  yhteydetAlateksti: "<p>Auto- ja py&ouml;r&auml;matkojen aika-arviot perustuvat Google Maps -karttapalvelun tietoihin. Junan aika-arviot koskevat VR:n nopeinta yhteytt&auml;.</p>",
  yhteydetAlateksti2: "<p>Bussit ja raitiovaunut: &nbsp;<a href=\"https://reittiopas.hsl.fi/\" target=\"_blank\" rel=\"noopener\">Avaa HSL:n Reittiopas</a></p>",
  vilkaisuja: [
    {
      id: "DatoCmsVilkaisujaPoint-2015301-fi",
      icon: asset("1577112507-i-dinner.svg"),
      teksti: "Yli 60 ravintolaa ja kahvilaa",
    },
    {
      id: "DatoCmsVilkaisujaPoint-2015302-fi",
      icon: asset("1577112509-i-entertainment.svg"),
      teksti: "Elämyksiä ja viihdettä aamusta yöhön",
    },
    {
      id: "DatoCmsVilkaisujaPoint-2015303-fi",
      icon: asset("1577112522-i-zen.svg"),
      teksti: "Liikuntaa, kauneutta ja hyvinvointia",
    },
    {
      id: "DatoCmsVilkaisujaPoint-2015304-fi",
      icon: asset("1577112510-i-grocery.svg"),
      teksti: "Kaikki arjen ostokset ja palvelut",
    },
    {
      id: "DatoCmsVilkaisujaPoint-2015305-fi",
      icon: asset("1577112510-i-hotel.svg"),
      teksti: "1000 yöpyjälle Hotellimajoitus",
    },
  ],
};

module.exports = { sijainti };
